export enum IconValues {
  attention = "attention",
  books = "books",
  booksColored = "booksColored",
  camera = "camera",
  caretDown = "caretDown",
  celebrate = "celebrate",
  chevronLeft = "chevronLeft",
  chevronRight = "chevronRight",
  edlink = "edlink",
  fasterSpeed = "fasterSpeed",
  fileUser = "fileUser",
  fileChartColumn = "fileChartColumn",
  fileChartColumnThin = "fileChartColumnThin",
  flexibleThinking = "flexibleThinking",
  functionIcon = "functionIcon",
  logo = "logo",
  logoInverted = "logoInverted",
  map = "map",
  mapGrowth = "mapGrowth",
  visualSpatialReasoning = "visualSpatialReasoning",
  workingMemory = "workingMemory",
  verbalMemory = "verbalMemory",
  verbalReasoning = "verbalReasoning",
  visualMemory = "visualMemory",
  visualMotorSpeed = "visualMotorSpeed",
  visualAbstractReasoning = "visualAbstractReasoning",
  warning = "warning",
  star = "star",
  asterisk = "asterisk",
  overall = "overall",
  stem = "stem",
  qrCode = "qrCode",
  list = "list",
  grid = "grid",
}

export interface IconProps {
  value: IconValues;
}
